export const /** @type {?} */ MODAL_STATUS = {
  SUCCESS: 'success',
  FAILED_TO_CANCEL: 'failed_to_cancel',
  FAILED: 'failed',
  ERROR: 'error',
};
